export const baseModalTitles = {
  baseModalTitleProfileUser: "Perfil de Usuario",
  baseModalTitleMobilePayment: "Pago Móvil",
  baseModalTitleInviteFriend: "Invitar Amigo",
  baseModalTitleChangePassword: "Cambiar Contraseña",
  baseModalTitleWithdrawal: "Retiro",
  baseModalTitleTransfer: "Transferir Dinero",
  baseModalTitleRegistration: "Registrate y Gana!",
  baseModalTitleSupport: "Soporte",
};
